// Generated by npm run git-info — do not edit by hand
export const commit = "5020efe";
